"use client";
import { HeaderData } from "../lib/features/header/header.types";
import { setHeader } from "../lib/features/header/header.slice";
import { store } from "../lib/store";

interface HeaderInitializerProviderProps {
  initialHeader?: HeaderData | null;
}

/**
 * SSR'dan gelen header verisini mount öncesi Redux store'a senkron yazar.
 * SettingsInitializerProvider ile aynı pattern:
 * - initialHeader varsa → store'a senkron yaz, AppEffects'deki fetchHeader() skip eder
 *   (header.thunk condition: data varsa return false).
 * - initialHeader yoksa → AppEffects fetchHeader() normal akışla çeker.
 *
 * NOT: Bu component render sırasında store.dispatch çağırır (hook dışı).
 * Redux Toolkit bunu destekler; senkron dispatch React lifecycle dışında çalışır.
 */
const HeaderInitializerProvider = ({ initialHeader }: HeaderInitializerProviderProps) => {
  if (initialHeader && !store.getState().header.data) {
    store.dispatch(setHeader(initialHeader));
  }
  return null;
};

export default HeaderInitializerProvider;